module.exports = __webpack_public_path__ + "img/order_img3.5a19bcf4.png";